import React from 'react';
import { Link } from 'react-router-dom';
import './nopage.scss'; 

function Nopage(){
  return (
    <div className="App">
      <header className="App-header">
          <h1 className="no-page-title">404</h1>
          <p className="no-page-message">Oops! The page you're looking for doesn't exist.</p>
          <Link to="/" className="no-page-link">Go Back to Home</Link>
          </header>
        </div>
  );
}

export default Nopage;
